import { authorizedApiClient } from "../config";
import { WorkspacePreferenceRequest, WorkspacePreferenceResponse } from "./preferenceEndpoints.interface";

export const readWorkspacePreference = async ({ workspace_id } : WorkspacePreferenceRequest) => authorizedApiClient.get<WorkspacePreferenceResponse>(`/${workspace_id}/preference`);

export const updateWorkspacePreference = async ({ workspace_id, ...preference }: WorkspacePreferenceRequest & Partial<WorkspacePreferenceResponse> & { preference?: any }) => {
  // Handle the case where data might be nested under a preference key
  // This happens when components pass the entire response from the API directly
  const preferenceData = (preference as any).preference;
  
  if (preferenceData && preferenceData.accounts && preferenceData.users) {
    // If we have a nested preference object with valid data, extract from that
    return authorizedApiClient.put<WorkspacePreferenceResponse>(`/${workspace_id}/preference`, {
      accounts: preferenceData.accounts,
      users: preferenceData.users,
      updated_by: preferenceData.updated_by,
      id: preferenceData.id
    });
  }
  
  // Standard case - extract accounts and users directly
  const { accounts, users, ...rest } = preference;
  
  // Only proceed if we have the required fields
  if (accounts && users) {
    return authorizedApiClient.put<WorkspacePreferenceResponse>(`/${workspace_id}/preference`, {
      accounts,
      users,
      updated_by: rest.updated_by,
      id: rest.id
    });
  }
  
  // If we don't have the required data, throw an error
  throw new Error('Missing required fields: accounts and users must be provided for preference update');
};
